import { render, staticRenderFns } from "./Resize.vue?vue&type=template&id=f2ec01e2"
import script from "./Resize.vue?vue&type=script&lang=js"
export * from "./Resize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2ec01e2')) {
      api.createRecord('f2ec01e2', component.options)
    } else {
      api.reload('f2ec01e2', component.options)
    }
    module.hot.accept("./Resize.vue?vue&type=template&id=f2ec01e2", function () {
      api.rerender('f2ec01e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Resize/Resize.vue"
export default component.exports